import clsx from 'clsx';

import styled from '@emotion/styled';

import { capitalize, formatForStatus } from '../../utils/utils';
import DotIcon from '../Icons/DotIcon';

// import { capitalize, formatForStatus } from '../../../utils/utils';

interface StatusCellProps {
  data?: Record<string, any>;
  statusKey?: string;
  plain?: boolean;
  customClasses?: string;
  useBoolean?: boolean;
  hasDot?: boolean;
  positiveType?: boolean;
}

const StatusCell: React.FC<StatusCellProps> = ({
  data,
  statusKey,
  plain = false,
  customClasses,
  useBoolean,
  hasDot,
  positiveType,
}) => {
  let label = data && data[statusKey ?? ''];
  const trueCase = positiveType ? 'positive' : 'active';
  const falseCase = positiveType ? 'negative' : 'inactive';

  if ((label === undefined || label === null || label === '') && !useBoolean) {
    label = statusKey;
  }

  if (data && typeof data['status'] === 'boolean') {
    label = Boolean(data['status']) ? trueCase : falseCase;
  }

  let formatStatus = formatForStatus(String(label) ?? '');

  if (plain) {
    formatStatus = label;
  }

  return (
    <StatusCellWrapper
      className={clsx(
        `${formatForStatus(String(label) ?? '')} status`,
        customClasses,
      )}
    >
      {hasDot && <DotIcon />}
      {capitalize(formatStatus)}
    </StatusCellWrapper>
  );
};

export default StatusCell;

const StatusCellWrapper = styled.div`
  display: flex;
  background-color: yellow;
  width: fit-content;
  align-items: center;
  line-height: 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 8px;
  padding: 4px 11px !important;
  user-select: none;
  height: fit-content;

  &.small-border-radius {
    border-radius: 4px;
  }

  &.declined {
    color: ${({ theme }) => theme.palette.errorRed};
    background-color: rgba(255, 5, 0, 0.1);
  }

  &.positive,
  &.confirmed {
    color: ${({ theme }) => theme.palette.greenColor};
    background-color: rgba(0, 183, 63, 0.05);
    border: 1px solid rgba(0, 183, 63, 0.1);
  }

  &.exclusive,
  &.processed,
  &.required,
  &.unknown {
    color: #139ab7;
    background-color: #f7fcfd;
    border: 1px solid ${({ theme }) => theme.palette.mediumBorder};
  }

  &.gig,
  &.hiring-conflict,
  &.notinitialized,
  &.not-initialized {
    color: #f46f3b;
    background-color: rgba(244, 111, 59, 0.1);
    border: 1px solid ${({ theme }) => theme.palette.mediumBorder};
  }

  &.pending,
  &.theft {
    background-color: rgba(213, 192, 27, 0.1);
    color: #d5c01b;
  }

  &.accepted,
  &.active,
  &.resolved,
  &.percentage,
  &.true {
    background-color: rgba(0, 183, 63, 0.1);
    color: #00b73f;
  }

  &.rejected,
  &.accident,
  &.negative,
  &.false {
    background-color: rgba(255, 5, 0, 0.1);
    color: #ff0500;
  }

  &.exited,
  &.expired,
  &.unemployed,
  &.delisted {
    background-color: rgba(107, 114, 128, 0.05);
    border: 1px solid rgba(107, 114, 128, 0.1);
    color: ${({ theme }) => theme.palette.grayTextColor};
  }
`;
